import React, { useState } from "react";
import "./SearchBar.css";

interface SearchBarProps {
  placeholder: string;
  onSearch: (value: string) => void;
  className?: string;
}

function SearchBar({ placeholder, onSearch, className = "" }: SearchBarProps) {
  const [inputValue, setInputValue] = useState<string>("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearch(inputValue);
    }
  };

  return (
    <div className={`search-bar ${className}`.trim()}>
      <input
        type="text"
        placeholder={placeholder}
        value={inputValue}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        className="search-input"
      />
    </div>
  );
}

export default SearchBar;
